import React, { useState } from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';

import { type HorizonTheme, Theme, Themes, ThemeStorageKey } from 'utils/color/horizonTheme';
import { getItem as getStorageItem, setItem as setStorageItem } from 'utils/storage';

export const ThemeProvider: React.FC<{ theme: Omit<HorizonTheme, 'onChange'> }> = ({
  children,
  ...props
}) => {
  const [currentThemeName, setCurrentThemeName] = useState<Theme>(
    (getStorageItem(ThemeStorageKey) ?? Theme.Light) as Theme
  );

  const handleChange = (themeName: Theme) => {
    setCurrentThemeName(themeName);
    setStorageItem(ThemeStorageKey, themeName);
  };

  return (
    <StyledComponentsThemeProvider
      {...props}
      theme={{
        ...Themes[currentThemeName],
        onChange: handleChange,
      }}
    >
      {children}
    </StyledComponentsThemeProvider>
  );
};
